module.exports = __webpack_public_path__ + "static/media/fb.28638ef8.svg";